export default {"src":"/_next/static/media/twitter-icon.3e64c8bf.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};